import { palette } from '../../styles/tokens';
import { Card } from '../common/Card';
import type { Business } from '../../types';

interface Props {
  business: Business;
  onSave: (updates: Partial<Business>) => Promise<boolean>;
}

const ROW: React.CSSProperties = { display: 'flex', alignItems: 'center', padding: '10px 0', borderBottom: `1px solid ${palette.g100}` };
const LABEL: React.CSSProperties = { fontSize: 13, color: palette.g500, width: 200, flexShrink: 0 };
const VALUE: React.CSSProperties = { fontSize: 13.5, fontWeight: 500, color: palette.g800, flex: 1 };

const LANGUAGES: { code: string; label: string }[] = [
  { code: 'en', label: 'English' },
  { code: 'fr', label: 'Fran\u00E7ais' },
  { code: 'ru', label: '\u0420\u0443\u0441\u0441\u043A\u0438\u0439' },
];

function Toggle({ on, onChange }: { on: boolean; onChange: () => void }) {
  return (
    <button onClick={onChange} style={{
      width: 40, height: 22, borderRadius: 11, border: 'none', cursor: 'pointer',
      background: on ? palette.accent : palette.g300, position: 'relative', transition: 'background 0.2s',
    }}>
      <div style={{
        width: 18, height: 18, borderRadius: 9, background: palette.white, position: 'absolute', top: 2,
        left: on ? 20 : 2, transition: 'left 0.2s', boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
      }} />
    </button>
  );
}

export function LanguageSection({ business, onSave }: Props) {
  const currentLang = business.client_language ?? 'en';
  const autoTranslate = business.auto_translate_messages ?? false;

  return (
    <Card title="Language & Communication">
      <div style={ROW}>
        <div style={LABEL}>App language</div>
        <div style={VALUE}>
          <span style={{ fontSize: 13, color: palette.g600 }}>
            {LANGUAGES.find(l => l.code === currentLang)?.label ?? 'English'}
          </span>
          <span style={{ fontSize: 11, color: palette.g400, marginLeft: 8 }}>(changeable on mobile)</span>
        </div>
      </div>

      <div style={ROW}>
        <div style={LABEL}>
          <div>Client communication language</div>
          <div style={{ fontSize: 11, color: palette.g400, marginTop: 2 }}>Invoices, quotes, and emails to clients</div>
        </div>
        <div style={VALUE}>
          <select value={currentLang} onChange={e => onSave({ client_language: e.target.value })} style={{
            padding: '6px 10px', borderRadius: 6, border: `1px solid ${palette.g200}`,
            fontSize: 13, fontFamily: 'inherit', color: palette.g700,
          }}>
            {LANGUAGES.map(l => <option key={l.code} value={l.code}>{l.label}</option>)}
          </select>
        </div>
      </div>

      <div style={{ ...ROW, borderBottom: 'none' }}>
        <div style={LABEL}>
          <div>Auto-translate messages</div>
          <div style={{ fontSize: 11, color: palette.g400, marginTop: 2 }}>Messages translated to recipient's preferred language</div>
        </div>
        <Toggle on={autoTranslate} onChange={() => onSave({ auto_translate_messages: !autoTranslate })} />
      </div>
    </Card>
  );
}
